import React from 'react';
import PageBanner from '../components/PageBanner';
import { PROJECTS } from '../data/mock';
import { MapPin, Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import CTASection from '../components/CTASection';

const BENEFITS = [
  {
    title: 'Empowerment Through Education',
    desc: 'We believe in the power of education to empower individuals and communities. Partner with us to make a lasting impact on girls and women through quality education and literacy enhancement programs.',
  },
  {
    title: 'A Commitment to Change',
    desc: 'MMF is driven by a passionate and committed team that is proactively working towards a brighter future for marginalized communities. Join us in our mission to create positive change.',
  },
  {
    title: 'Global Collaboration',
    desc: 'MMF collaborates with organizations and individuals on an international scale to address educational disparities. Work with us to be part of a global network focused on promoting gender equality and education.',
  },
];

const Projects = () => {
  return (
    <main>
      <PageBanner title="Our Projects" crumb="Projects" />
      <section className="py-20 md:py-24 bg-white">
        <div className="max-w-[1200px] mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {PROJECTS.map((p, i) => (
              <article
                key={i}
                data-testid={`project-card-${i}`}
                className="bg-white rounded-sm overflow-hidden shadow-sm card-lift border border-slate-100 flex flex-col"
              >
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={p.image}
                    alt={p.title}
                    className="w-full h-full object-cover transition-transform duration-700 hover:scale-110"
                  />
                </div>
                <div className="p-7 flex flex-col flex-1">
                  <div className="flex items-center gap-2 text-[#F97559] text-sm font-semibold mb-3">
                    <MapPin size={16} />
                    <span>{p.location}</span>
                  </div>
                  <h3 className="heading-display text-xl font-bold text-slate-900 leading-snug">
                    {p.title}
                  </h3>
                  <p className="mt-4 text-slate-600 text-sm leading-7 flex-1">
                    {p.desc}
                  </p>
                  <Link
                    to="/contact"
                    data-testid={`project-join-${i}`}
                    className="mt-6 inline-block self-start bg-[#2BBECF] hover:bg-[#229bab] text-white font-semibold px-6 py-2.5 rounded-sm transition-colors text-sm"
                  >
                    Join us
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* MMF Benefits */}
      <section className="py-20 md:py-24 bg-[#FFF6F2]" data-testid="mmf-benefits-section">
        <div className="max-w-[1200px] mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="relative h-[520px] md:h-[600px] overflow-hidden shadow-2xl rounded-sm">
              <img
                src="https://customer-assets.emergentagent.com/job_site-architecture-1/artifacts/mwr4pvvm_14.jpeg"
                alt="MMF partnership and collaboration"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-4 md:right-8 bg-[#F97559] text-white px-7 py-5 shadow-xl flex items-center gap-4 max-w-[230px]">
              <div className="w-12 h-12 rounded-full border-2 border-white grid place-items-center text-2xl font-bold">
                <span>30</span>
              </div>
              <div className="leading-tight">
                <p className="heading-display text-lg font-bold">30 Years</p>
                <p className="text-xs uppercase tracking-wider">Experience</p>
              </div>
            </div>
          </div>

          {/* Copy */}
          <div>
            <p className="uppercase text-xs tracking-[0.3em] font-bold text-[#C9A23E] mb-3">
              Why Choose Us?
            </p>
            <h2 className="heading-display text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 leading-tight">
              MMF Benefits
            </h2>

            <div className="mt-8 space-y-7">
              {BENEFITS.map((b, i) => (
                <div key={i} className="flex gap-4">
                  <div className="shrink-0 w-9 h-9 rounded-full bg-[#2BBECF] grid place-items-center text-white">
                    <Check size={18} strokeWidth={3} />
                  </div>
                  <div>
                    <h3 className="heading-display text-lg font-bold text-slate-900">
                      {b.title}
                    </h3>
                    <p className="mt-2 text-slate-600 text-[15px] leading-7">
                      {b.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CTASection />
    </main>
  );
};

export default Projects;
